/* istanbul ignore file */
import React from 'react';
import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';
import { useServiceUrl } from 'domain/shared/service';

interface EditServiceButtonProps extends EditButtonProps {}

const EditServiceButton = (props: EditServiceButtonProps) => {
  const { getUpdateEntityUrl } = useServiceUrl();

  return <EditButton path={id => getUpdateEntityUrl(id)} {...props} />;
};

export default EditServiceButton;
